module.exports = __webpack_public_path__ + "static/img/p3.7425204.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p3.jpg
// module id = zHb/
// module chunks = 1